<section tuiContent>
	<p
		class="mt-0 mb-4"
		[innerHTML]="
			'support.help-description' | transloco: { email: supportEmail }
		"
	></p>

	@if (form) {
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<label tuiLabel>
				{{ 'app.app-version' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input formControlName="version" tuiInput type="text" />
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.email' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="email"
						tuiInput
						autocomplete="email"
					/>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.name' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="name"
						tuiInput
						autocomplete="name"
					/>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.organization' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="organizationName"
						tuiInput
						autocomplete="organizationName"
					/>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.message' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<textarea
						tuiTextarea
						formControlName="message"
						[limit]="maxLength"
					></textarea>
				</tui-textfield>

				<tui-error formControlName="message" />
			</label>
		</form>
	}
</section>

<footer tuiFooter>
	<button
		tuiButton
		appearance="accent"
		[loading]="busy()"
		(click)="onSubmit()"
	>
		{{ 'action.send' | transloco }}
	</button>
</footer>
